import React, { useState, useRef } from 'react';
import './WinnerThumbnail.css';
import { useFitTextToRows } from '../../../../../shared/src/hooks/use-fit-text-to-rows.hook';
import { Image } from '../../../../../shared/src/components/Image';
import { useAsgFadeInAnimation } from '../../../../../shared/src/hooks/use-asg-animations.hook';
import { useDispatch } from 'react-redux';
import { useImgDominantColor } from '../../../../../shared/src/hooks/use-img-dominant-color.hook';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';

export const WinnerThumbnail = ({
    winner,
    playNowHandler,
}) => {
    const [overlayActive, setOverlayActive] = useState(false);
    const [imgDominantColor, setImgDominantColor] = useState('var(--cs-secondary-background-color)');
    const winnerTextRef = useRef();
    const winnerOverlayTextRef = useRef();
    const dispatch = useDispatch();
    const { t } = useTranslations();

    const cmsWinnerImage = winner.game.images.horizontalRectangleImage ?? winner.game.images.default;

    const changeImageSize = (string) => {
        return string.replace('290x192', '594x192').replace('1x', '2x');
    };
    const images = {
        // we can't rely on image size in image URL for CMS games. We need to use the default image as is for CMS games
        default: winner.game.isCmsGame  ? cmsWinnerImage : changeImageSize(winner.game.images.default),
        webp: winner.game.isCmsGame  ? cmsWinnerImage : changeImageSize(winner.game.images.webp)
    };

    // show animation on every winner change
    const {
        animationEnabled,
        animationClassName,
    } = useAsgFadeInAnimation(1000, [winner]);

    useImgDominantColor(
        winner.game.images.webp,
        ({ r, g, b }) => {
            setImgDominantColor(`rgb(${r}, ${g}, ${b})`);
        },
        [winner],
    );

    useFitTextToRows(
        winnerTextRef,
        3,
        [winner],
    );

    useFitTextToRows(
        winnerOverlayTextRef,
        2,
        [winner],
    );

    const openGame = () => {
        dispatch(playNowHandler({
            gameId: winner.game.id,
        }));
    };

    return (
        <div
            className={`asg-winner-thumbnail ${animationEnabled ? animationClassName : ''}`}
            onMouseEnter={() => { setOverlayActive(true); }}
            onMouseLeave={() => { setOverlayActive(false); }}
            style={{
                '--asg-animation-fade-in-duration': '1s',
            }}
        >
            <Image
                images={images}
                className="asg-winner-thumbnail__img"
                loadingIcon="winner"
                alt={winner.game.name}
            />

            <div className="asg-winner-thumbnail__details" style={{
                backgroundColor: imgDominantColor,
            }}>
                <div className="asg-winner-thumbnail__text" ref={winnerTextRef}>
                    {winner.playerName}{' '}
                    <span className="asg-winner-thumbnail__text--low">{t('played')}</span>{' '}
                    {winner.gameName}{' '}
                    <span className="asg-winner-thumbnail__text--low">{t('andWon')}</span>{' '}
                    <span className="asg-winner-thumbnail__text-amount">
                        {`${winner.currencySymbol}${parseInt(winner.winAmount, 10)}`}
                    </span>
                </div>
                <div className="asg-winner-thumbnail__gradient" style={{
                    background: `linear-gradient(0deg, ${imgDominantColor} 0%, transparent 100%)`
                }}/>
            </div>

            {overlayActive && <div
                className="asg-winner-thumbnail__overlay"
                onClick={openGame}
            >
                <span ref={winnerOverlayTextRef}>{`${t('play')} ${winner.game.name}`}</span>
            </div>}
        </div>
    );
};
